module.exports = __webpack_public_path__ + "img/Romina-Sanchez-color.87223499.jpg";